import React, { Fragment } from 'react';
import { Provider } from 'mobx-react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

import { routes } from '../stores';
import BuyTicket from './tickets/Main';
import { BuyVoucher } from './vouchers';
import { colors } from 'app/variables';

const GlobalStyles = createGlobalStyle`
  a:hover, a:focus {
    color: ${colors.pacificBlue} !important;
    text-decoration: none !important;
  }
`;

const PublicTicketRoot = () => (
  <Provider routes={routes}>
    <Fragment>
      <GlobalStyles />
      <BrowserRouter>
        <Switch>
          <Route exact path={routes.couponDetail} component={BuyTicket} />
          <Route exact path={routes.eventDetail} component={BuyTicket} />
          <Route
            exact
            path={routes.voucherDetail}
            render={(props) => <BuyVoucher {...props} isWithdrawal={false} />}
          />
          <Route
            exact
            path={routes.voucherWithdrawal}
            render={(props) => <BuyVoucher {...props} isWithdrawal={true} />}
          />
        </Switch>
      </BrowserRouter>
    </Fragment>
  </Provider>
);

export default PublicTicketRoot;
